import { APIEndpoints } from "../../constants";
import { APIPost, getAuthHeaders, APIResponse } from "../api/common.service";
import {
  CreateAnnouncementRequest,
  CreateAnnouncementResponseData,
  EditAnnouncementRequest,
  EditAnnouncementResponseData,
  COQLRequest,
  AnnouncementSearchResponseData,
} from "../../types";

export function CreateAnnouncement(
  body: CreateAnnouncementRequest,
  options?: { skipLoader?: boolean },
): Promise<APIResponse<CreateAnnouncementResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<CreateAnnouncementResponseData>(
      APIEndpoints.CreateAnnouncement,
      headers,
      undefined,
      body as unknown as Record<string, unknown>,
      options,
    ),
  );
}

export function EditAnnouncement(
  body: EditAnnouncementRequest,
  options?: { skipLoader?: boolean },
): Promise<APIResponse<EditAnnouncementResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<EditAnnouncementResponseData>(
      APIEndpoints.EditAnnouncement,
      headers,
      undefined,
      body as unknown as Record<string, unknown>,
      options,
    ),
  );
}

export function SearchAnnouncements(
  body: COQLRequest,
  options?: { skipLoader?: boolean },
): Promise<APIResponse<AnnouncementSearchResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<AnnouncementSearchResponseData>(
      APIEndpoints.SearchAnnouncements,
      headers,
      undefined,
      body as unknown as Record<string, unknown>,
      options,
    ),
  );
}
